import { api, download } from "../helpers";

export const getPresets = (payload, token) =>
	api("/tournaments/presets", "GET", payload, {}, token);

export const createPresetItem = ({ id, ...payload }, token) =>
	api("/tournaments/presets/" + id, "POST", payload, {}, token);

export const deletePresetItem = ({ id, itemId }, token) =>
	api("/tournaments/presets/" + id, "DELETE", { id: itemId }, {}, token);

export const deleteTournament = (id, token) =>
	api("/tournaments/" + id, "DELETE", undefined, undefined, token);

export const getTournaments = (params, token) =>
	api("/tournaments", "GET", undefined, params, token);

export const getTournamentJoined = ({ id, ...params }, token) =>
	api("/tournaments/" + id + "/joined", "GET", undefined, params, token);

export const getDetail = ({ id }, token) =>
	api("/tournaments/" + id, "GET", undefined, undefined, token);

export const updateStatus = ({ id, ...payload }, token) =>
	api("/tournaments/" + id + "/status", "PUT", payload, undefined, token);

export const updateResults = ({ id, ...payload }, token) =>
	api("/tournaments/" + id + "/results", "PUT", payload, undefined, token);

export const joinTournament = ({ id, ...payload }, token) =>
	api("/tournaments/" + id + "/join", "POST", payload, undefined, token);

export const withdrawTournament = ({ id, ...payload }, token) =>
	api("/tournaments/" + id + "/withdraw", "POST", payload, undefined, token);

export const getResults = ({ id, ...param }, token) =>
	api("/tournaments/" + id + "/results", "GET", undefined, param, token);

export const exportTournaments = (params, token) =>
	download("/tournaments/export", params, token);
